<template>
	<div class="MainApp" style="back">
		

				<div  v-if="$store.state.loading == false">
					<div class="overlay"></div>
					<div class="hp">
						<section class="hpSearchSection">
							<section class="searchSection" style="width: 100%;">
								<div class="accordion">
									<div class="searchHeader">
										<h1 class="mainTitle">
											{{ mainTitle  }}
										</h1>
									</div>
										
									<div class="collapse show" v-show="$store.state.loading == false">
										<div class="mobile-toggle-search">
											<div class="magnifyWrap">
												<span>
													<svg
														width="24px"
														height="24px"
														viewBox="0 0 24 24"
														version="1.1"
														class="magnifyIcon"
													>
														<title>search</title>
														<g
															id="search-24"
															stroke="none"
															stroke-width="1"
															fill="none"
															fill-rule="evenodd"
														>
															<rect
																id="Rectangle"
																x="0"
																y="0"
																width="24"
																height="24"
															></rect>
															<path
																d="M18.0104076,15.5104076 L21.0104076,15.5104076 L21.0104076,22.0104076 C21.0104076,22.8388348 20.3388348,23.5104076 19.5104076,23.5104076 C18.6819805,23.5104076 18.0104076,22.8388348 18.0104076,22.0104076 L18.0104076,15.5104076 L18.0104076,15.5104076 Z"
																id="Rectangle-hand"
																fill="#000000"
																transform="translate(19.510408, 19.510408) rotate(-45.000000) translate(-19.510408, -19.510408)"
															></path>
															<circle
																id="Oval"
																stroke="#000000"
																stroke-width="2"
																cx="10.5"
																cy="10.5"
																r="8.5"
															></circle>
														</g>
													</svg>
												</span>
											</div>
										</div>
										<SearchBox v-if="$route.query.view == null"></SearchBox>	
									
														
									</div>
								</div>
							</section>
						</section>
						<section class="infoSection">
							<div class="trendsContainer">
								<div class="imgContainer">
									<img class="trendsPic" src="/images/trendsimg.png" alt="" />
								</div>
								<div class="content">
									<h2 class="title">הבית לנתוני הנדל"ן הממשלתיים</h2>
									<p class="plainText">
										באתר נתונים אודות נכסים ועסקאות שעברו טיוב, תקנון וסינון, מתוך מסדי הנתונים השונים של משרדי הממשלה העוסקים בתחום הנדל"ן. המידע המוגש לציבור הרחב יוצר שקיפות במידע לכלל המשתמשים בצורה קלה על גבי מפה, ומסייע בקבלת החלטות בשוק הנדל"ן. ניתן לחפש מידע על נכסים ועסקאות על גבי מפה, חיפוש חופשי, גוש/חלקה, שכונה וכתובת.
									</p>
									
								</div>
							</div>
							<div class="allInfoContainer">
								<h2 class="title">כל המידע שצריך - במקום אחד!</h2>
								<div class="boxContainer">
									<div class="imageBox">
										<div class="imgWrap">
											<img class="icon" src="/images/watchIcon.png" alt="" />
										</div>
										<div class="content">
											<h3 class="subTitle">צפו</h3>
											<p class="text">
												צפו בפרטי הנכס המלאים ובהיסטורית עסקאות טרם הרכישה
											</p>
										</div>
									</div>
									<div class="imageBox">
										<div class="imgWrap">
											<img class="icon" src="/images/exploreIcon.png" alt="" />
										</div>
										<div class="content">
											<h3 class="subTitle">חקרו</h3>
											<p class="text">
												חקרו שכונות וגלו איזורים שמתאימים עבורכם בקלות ובמהירות
											</p>
										</div>
									</div>
									<div class="imageBox">
										<div class="imgWrap">
											<img class="icon" src="/images/compareIcon.png" alt="" />
										</div>
										<div class="content">
											<h3 class="subTitle">השוו</h3>
											<p class="text">
												השוו בין מחירי עסקאות ושכירויות בשכונות ויישובים שונים
											</p>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section class="hpArticleSection">
							<div class="hpArticle" style="background-image: url(/images/unsplash-copy.png)">
								<div style="min-height: 234px;"></div>
							</div>
							<!-- <div class="hpArticle" style="background-image: url(/images/unsplash-copy-2.png)">
								<div style="min-height: 234px;"></div>
							</div> -->
						</section>
					</div>
				</div>
			
		

		<div class="loading-container" v-else>
			<svg viewBox="25 25 50 50" class="loader-svg">
				<circle
					class="loader-path"
					cx="50"
					cy="50"
					r="20"
					fill="none"
					stroke="#1990d4"
					stroke-width="2"
				/>
			</svg>
		</div>





	</div>
</template>


<script>

import SearchBox from "@/components/SearchBox";

export default {
	name: "HomeView",
	components: {
		SearchBox,
	},
	data() {
		return {
				query: "",
				items: [],
				showContactMsg: false,
				contactText: "",
				name: "",
				emailAddress: "",
				subject: "",
				application: "",
				recaptchaWidgetId: null,
				isRecaptchaValid: false,
				contactModal: false,
			};
	},
	mounted() {
		var appVue = this;
		var inputElement1 = document.getElementById("myInput2");
		//add Enter Key event
		inputElement1.addEventListener("keyup", function (event) {
			if (event.keyCode === 13) {
				event.preventDefault();
				appVue.showResults();
			}
		});
	},
	computed: {
		mainTitle() {
			//if domain is 'dev.nadlan.gov.il' or 'localhost', show 'אתר הנדל"ן הממשלתי - טסט מפ"י'
			if (window.location.host.includes("dev.nadlan.gov.il") || window.location.host.includes("localhost")) {
				return 'אתר הנדל"ן הממשלתי - טסט מפ"י'
			}
			return 'אתר הנדל"ן הממשלתי'
		},
		config() {
			return this.$store.state.config;
		},
	},
	methods: {
		verifyCallback(response) {
			if (response) {
				this.isRecaptchaValid = true;
			}
		},
		expiredCallback() {
			this.isRecaptchaValid = false;
		},
		submitContact(recaptcha) {
			var appVue = this;
						var name = this.name;
						var emailAddress = this.emailAddress;
						var subject = this.subject;
						var application = this.application;

						// Validate input and reCAPTCHA
						if (!name || !emailAddress || !subject || !application) {
				// set error msg
				appVue.statusText = "נא למלא את כל השדות";
								return;
			}

						// Send data to server
						fetch(appVue.$state.store.congfig.api_base+'/ContactUs', {
								method: 'POST',
								headers: {
										'Content-Type': 'application/json',
								},
								body: JSON.stringify({ name, emailAddress, subject, application, recaptcha })
						})
						.then(response => response.json())
						.then(() => {
								
								appVue.statusText = "הודעתך נשלחה בהצלחה!";

				alert('הודעתך נשלחה בהצלחה!');
				/* global grecaptcha */
								grecaptcha.reset();
				//close modal after 3 seconds
				setTimeout(() => {
					appVue.contactModal = false;
					appVue.showContactMsg = true;
					appVue.contactText = "הודעתך נשלחה בהצלחה!";
				}, 1000);
						})
						.catch((error) => {
								console.error('Error:', error);
								//alert('התרחשה שגיאה בשליחת ההודעה');
				appVue.statusText = "התרחשה שגיאה בשליחת ההודעה";
						});
				},
		handleSubmit() {
			const response = grecaptcha.getResponse(this.recaptchaWidgetId);
			if (response.length === 0) {
				alert("Please complete the reCAPTCHA");
				return;
			} else {
				// Proceed with form submission
				alert("Form submitted successfully");
				this.submitContact(response);
			}
		},
		async showResults() {
			var appVue = this;
			await appVue.mixin_showResults(appVue);
		},
	},
};
</script>

<style>


.autocomplete-container {
	display: flex;
	justify-content: center;
	/* width: 100%; */
	max-width: 700px;
	top: 25px;
	position: absolute;
}
	
	.autocomplete {
	border: 1px solid rgb(138, 138, 138);
	width: 400px;
	border: 1px solid transparent;
	margin: 3px;
	}
	
	
		@media screen and (max-width: 600px) {
		.autocomplete {
			width: 100%;
		}
		.autocomplete-container{
			top:0px;
			position: relative;
			margin: auto;
			width:100%;
		}
		.autocomplete-items {
			width: 100%;
		}
			
		}
		/* left: 50%;
		transform: translateX(-50%); */
		/* autocomplete-container if desktop */
	
		@media screen and (min-width: 600px) {
		.autocomplete-container{
		left: 50%;
			transform: translateX(-50%);
		}
			
		}

		

		.autocomplete input {
				font-family: "Open Sans", sans-serif;
				font-optical-sizing: auto;
				font-style: normal;
				font-variation-settings:
						"wdth" 100;
			border: 1px solid transparent;
			background-color: white;
			padding: 10px;
			font-size: 14px;
			border: 1px solid transparent;
			background-color: #f1f1f1;
			width: 100%;
		}


		.autocomplete-items {
			font-size: 14px !important;
			position: absolute;
			border: 1px solid #d4d4d4;
			border-top: none;
			top: 100%;
			/* width: 100%; */
			overflow-y: auto;
			max-height: calc(100vh - 200px);
			font-family: "Open Sans", sans-serif;
				font-optical-sizing: auto;
				font-style: normal;
				/* left-to-right */
				text-align: right;
				background-color: white
		}



		.autocomplete-items::-webkit-scrollbar {
			width: 10px;
		}


		/* Track */
		::-webkit-scrollbar-track {
			background: #f1f1f1;
		}

		/* Handle */
		::-webkit-scrollbar-thumb {
			background: #888;
		}

		/* Handle on hover */
		::-webkit-scrollbar-thumb:hover {
			background: #555;
			/* transition: background 0.5s; */
		}

		.autocomplete-items div {

			margin: 5px;
			cursor: pointer;
			background-color: #fff;
		}

		/* When hovering an item */
		.autocomplete-items div:hover {
			background-color: #e9e9e9;
		
		}


		/* When navigating through the items using the arrow keys */
		.autocomplete-active {
			background-color: DodgerBlue !important;
			color: #ffffff;
		}

		.autocomplete-error-msg {
			display: block;
			position: absolute;
			top: 100%;
			right: 0px;
			z-index: 10;
			width: 100%;
			color: #ff5959;
			font-size: 20px;
			background: rgba(228, 228, 228, 0.77);
			text-align: center;
			margin-top: 5px;
		}

		.autocomplete-error-msg.show {
			visibility: visible;
			opacity: 1;
		}

		.autocomplete-error-msg.hide {
			visibility: hidden;
			opacity: 0;
			transition: visibility 0s 2s, opacity 2s linear;
		}

		.autocomplete-badge {
			font-size: 14px !important;
			position: absolute;
			left: 2px;
			font-weight: 400;
			border-radius: 50%;
			display: inline-block;
			text-align: center;
			padding-left: 8px;
			padding-right: 8px;
			opacity: 0.4;
		}

		* {
			box-sizing: border-box;
		}

body {
	height: 100%;
	direction: rtl;
	margin: 0;
	font-size: 10px !important;
	font-family: "rubik", arial;
	text-align: right;
	color: #02234b;
	font-size: 10px;
	line-height: initial;
}

.autosuggest__suggestions-container {
	font-size: 10px !important;
	font-family: "rubik", arial;
	text-align: right;
	color: #02234b;
	line-height: normal;
	direction: rtl;
	box-sizing: border-box;
}

.test {
	font-size: 10px !important;
	font-family: "rubik", arial;
	text-align: right;
	color: #02234b;
	line-height: normal;
	direction: rtl;
	box-sizing: border-box;
	position: absolute;
	border: 1px solid #d4d4d4;
	border-top: none;
	z-index: 99;
	top: 100%;
	left: 0;
	right: 0;
	overflow-y: auto;
	max-height: calc(100vh - 200px) /*todo mobile, calc, scroll on key up/down*/;
}




</style>
